import React from "react";
import { connect } from "react-redux";
import styles from "./Footer.module.css";
import { Link } from "react-router-dom";
import location from "../../assets/Location.png";
import playstore from "../../assets/Google play.png";
import apple_store from "../../assets/App store.png";
import { EnvironmentOutlined, MailOutlined } from "@ant-design/icons";
import facebook from "../../assets/facebook.png";
import { VERSION } from "../../Utils/APIManager";
const footer = ({ isTamil }) => {
  const navLinks = [
    { to: "/", label: isTamil ? "முகப்பு" : "Home" },
    { to: "/introduction_page", label: isTamil ? "முன்னுரை" : "Introduction" },
  ];

  const subLinks = [
    { to: "/idioms", label: isTamil ? "- மரபுத்தொடர்கள்" : "- Idioms" },
    { to: "/metaphor", label: isTamil ? "- உவமைத்தொடர்கள்" : "- Metaphors" },
    { to: "/phrasemes", label: isTamil ? "- இணைமொழிகள்" : "- Phrasemes" },
  ];

  const legalLinks = [
    {
      to: "/TermsAndConditions",
      label: isTamil ? "விதிமுறைகள் மற்றும் நிபந்தனைகள்" : "Terms and Conditions",
    },
    {
      to: "/Privacypolicy",
      label: isTamil ? "தனியுரிமைக் கொள்கை" : "Privacy Policy",
    },
    { to: "/disclaimer", label: isTamil ? "பொறுப்புத் துறப்பு" : "Disclaimer" },
  ];

  const socialIcons = [
    { icon: "📘", label: "Facebook" },
    { icon: "🐦", label: "Twitter" },
    { icon: "📸", label: "Instagram" },
  ];

  return (
    <>
      <footer className={styles.footer}>
        <div className={styles.footer__section}>
          <div className={styles.footer__heading}>
            {isTamil ? "பயனுள்ள இணைப்புகள்" : "Helpful Links"}
          </div>
          <div className={styles.footer__list}>
            {navLinks.map((item, index) => (
              <div key={index} className={styles.footer__listItem}>
                <Link
                  style={{ marginTop: "4rem" }}
                  className={styles.footer__link}
                  to={item.to || "#"}
                >
                  {item.label}
                </Link>
              </div>
            ))}
          </div>

          <div className={styles.footer__list}>
            <div className={styles.footer_list_01}>
              {isTamil ? "உருவக மொழிகள் :" : "Figurative Languages :"}
            </div>
            {subLinks.map((item, index) => (
              <div key={index} className={styles.footer__listItem}>
                <Link className={styles.footer__link} to={item.to}>
                  {item.label}
                </Link>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.footer__section}>
          <div className={styles.footer__heading}>
            {isTamil ? "சட்டரீதியான தகவல்கள்" : "Legal Information"}{" "}
          </div>
          <div className={styles.footer__list}>
            {legalLinks.map((item, index) => (
              <div key={index} className={styles.footer__listItem}>
                <Link className={styles.footer__link} to={item.to}>
                  {item.label}
                </Link>
              </div>
            ))}
          </div>
        </div>

        <div className={`${styles.footer__section} ${styles.footer__contact}`}>
          <div className={styles.footer__heading}>
            {isTamil ? "எங்களைத் தொடர்பு கொள்க" : "Contact Us"}
          </div>
          <p className={styles.locationBlock}>
            <EnvironmentOutlined
              src={location}
              className={styles.image_location}
              alt="Location"
            />
            <div className={styles.address}>
              230 Victoria Street
              <br />
              #15-01/08, Bugis Junction Towers
              <br />
              Singapore - 188024.
            </div>
          </p>

          <p className={styles.footer_email_adjustment}>
            <MailOutlined className={styles.email} />
            <a
              className={`${styles.footer__link} ${styles.footer_email}`}
              href="mailto:sales@cosmicconsultancy.com"
            >
              sales@cosmicconsultancy.com
            </a>
          </p>
        </div>

        <div className={styles.footer__section}>
          <div className={styles.footer__heading}>
            {isTamil ? "மின் அகரத்தை பதிவிறக்குங்கள்" : "Get Min Agaram"}
          </div>
          <div className={styles.footer__apps}>
            <a
              href="https://apps.apple.com/sg/app/min-agaram/id6483002626" // Replace with your actual Apple Store link
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className={styles.playstore_image}
                src={apple_store}
                alt="Download on the App Store"
              />
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=com.tamil_agarathi_updated" // Replace with your actual Play Store link
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className={styles.playstore_image1}
                src={playstore}
                alt="Get it on Google Play"
              />
            </a>
          </div>

          <div className={styles.footer__heading}>
            {isTamil ? "உதவி பெறுங்கள்" : "Get Help"}
          </div>
          <p>
            <a
              className={styles.footer__link_001}
              href="mailto:support@minagaram.com"
            >
              support@minagaram.com
            </a>
          </p>

          <div className={`${styles.footer__heading} ${styles.new_follow}`}>
            {isTamil ? "எங்களைப் பின்தொடருங்கள்" : "Follow Us"}
          </div>

          <div style={{width:"50px"}}>
            <a
            
              href="https://www.facebook.com/minagaramfbp/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className={styles.facebook_image}
                src={facebook}
                alt="Facebook"
                
              />
            </a>
          </div>
        </div>
      </footer>
      <div className={styles.footer__bottom}>
        <div className={styles.footer__logo}>
          <img
            src="https://tamileagarathi.s3.ap-south-1.amazonaws.com/siteimages/Agarathi.png"
            alt="Logo"
          />
          <strong className={styles.new_minagaram_tittle}>
            {isTamil ? "மின் அகரம்" : "Min Agaram"}
          </strong>
          {/* <p className={styles.new_minagaram_new_one}>
            © 2024-2025 Cosmic Consultancy Services Pte Ltd. All Rights
            Reserved.
          </p> */}
        </div>
        <p className={styles.new_minagaram_new_one}>
          © 2024-2026 Cosmic Consultancy Services Pte Ltd. All Rights Reserved.
        </p>
        <div>
          <p className={styles.version}>
            {isTamil ? "பதிப்பு" : "Version"} {VERSION}
          </p>
        </div>
      </div>
    </>
  );
};

// Map Redux state to component props
const mapStateToProps = (state) => ({
  isTamil: state.LanguageReducer.isTamil,
});

// Connect component to Redux store
export default connect(mapStateToProps)(footer);
